// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"375":"379140fa","806":"c38b35fe"}[chunkId] + ".chunk.css";
};